<div>

    <h3>{{ 'sipo.sign-component.final-component.signing-details' | translate }}</h3>

    <p><strong>{{ 'sipo.sign-component.final-component.signing-process-id' | translate }}
        :</strong> {{ signerData.signingProcessId }}</p>
    <p><strong>{{ 'sipo.sign-component.final-component.file-id' | translate }}:</strong> {{ signerData.fileId }}</p>
    <div class="flex">
        <p>
            <strong>{{ 'sipo.sign-component.final-component.signing-type' | translate }}:</strong>
        </p>
        <div class="w-6rem ml-2" [innerHTML]="signerData.signingType | evidenceSvg"></div>
    </div>

    <!--
    <p><strong>{{ 'sipo.sign-component.final-component.multiple-signers' | translate }}
        :</strong> {{ signerData.multipleSigners ? 'Yes' : 'No' }}</p>
    <p><strong>{{ 'sipo.sign-component.final-component.i-sign' | translate }}
        :</strong> {{ signerData.iamsigning ? 'Yes' : 'No' }}</p>
        -->
    <div *ngIf="signerData?.signers?.length">

        <strong>{{ 'sipo.sign-component.final-component.signers' | translate }}:</strong>
        <ul>
            <li *ngFor="let signer of signerData.signers">
                {{ signer.fullName }} / {{ signer.email }}
            </li>
        </ul>

    </div>

    <!--
    <div *ngIf="signerData.signpositions?.length">
        <p><strong>{{ 'sipo.sign-component.final-component.sign-positions' | translate }}
            :</strong> {{ countSignPositions }}</p>
    </div>
    -->
    <div *ngIf="signerData.observers?.length">

        <p><strong>{{ 'sipo.sign-component.final-component.observers' | translate }}:</strong>
            <!-- {{ signerData.observers }}</p>-->
                <ul>
                    <li *ngFor="let obs of signerData.observers">
                        {{ obs }}
                    </li>
                </ul>
    </div>
    <div *ngIf="signerData.message">
        <br>
        <p><strong>{{ 'sipo.sign-component.final-component.messages' | translate }}:</strong></p>
        <p>{{ signerData.message }}</p>
        <p>&nbsp;</p>
    </div>

    <div *ngIf="signerData.additionalFiles?.length">
        <p><strong>{{ 'sipo.sign-component.final-component.additional-files' | translate }}</strong></p>
        <ul>
            <li *ngFor="let file of signerData.additionalFiles">
                <a href (click)="openBase64File(file)" style="cursor: pointer;">
                    {{ file.name }}
                </a>
            </li>
        </ul>
    </div>
</div>
